// @core/api/endpoints/license/heartbeat.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  HeartbeatRequest,
  HeartbeatResponse,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Heartbeat 
 * Performs heartbeat operation on .
 */
export async function Heartbeat(
  data: HeartbeatRequest,
  options?: RequestOptions
): Promise<HeartbeatResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/heartbeat`;
  const requestOptions = options;
  return client.post<HeartbeatResponse>(requestPath, data, requestOptions);
}
